
import BestGallery from './components/BestGallery';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsBestGallery.WidgetCategoryReviewsBestGalleryMobile',
  name: 'WidgetCategoryReviewsBestGalleryMobile',
  components: { BestGallery }
};
